








































import Vue from 'vue'
import { mapState, mapGetters } from 'vuex'
import { AccessRight } from '../interfaces/admin-console'

import Alerts from '@/components/Alerts.vue'
import DataExport from '@/components/helper-components/DataExport.vue'
import EmailReports from '@/components/EmailReports.vue'

export default Vue.extend({
  components: {
    Alerts,
    DataExport,
    EmailReports
  },

  props: {
    userId: Number
  },

  data () {
    return {
      dashboardTabOptions: [{
        name: 'Metrics Summary',
        url: '/home'
      }, {
        name: 'Local Overview',
        url: '/local-ops-dashboard-overview'
      }, {
        name: 'Metrics By Region',
        url: '/local-ops-dashboard-metrics-by-region'
      }, {
        name: 'Unit Economics',
        url: '/local-ops-dashboard-unit-economics'
      }, {
        name: 'Unit Economics Leaderboard',
        url: '/unit-economics-leaderboard'
      }],
      selectedDashboardUrl: ''
    }
  },

  computed: {
    ...mapState('adminConsole', {
      accessRights: 'accessRights'
    }),

    ...mapState('customDashboard', {
      currentDashboard: 'currentDashboard'
    }),

    ...mapGetters('customDashboard', {
      currentExportedData: 'currentExportedData'
    })
  },

  created () {
    this.selectedDashboardUrl = this.$route.path

    if (!this.accessRights.length) {
      this.$store.dispatch('adminConsole/getAccessRights')
    }
  },

  methods: {
    checkAccessRight (dashboardName: string): boolean {
      const accessRight = (this.accessRights as AccessRight[]).find(access => access.moduleSection === dashboardName)
      if (!accessRight) {
        return true
      }

      return accessRight.allowedUsers.some(email => email.toLowerCase() === this.$auth.getUser().email.toLowerCase())
    },

    switchDashboard (url: string) {
      this.selectedDashboardUrl = url
      setTimeout(() => {
        this.$router.push(url)
      }, 100)
    }
  }
})
